// AUTH
export const LOGIN_ADMIN = 'LOGIN_ADMIN'

// ROLES
export const GET_ROLES = 'GET_ROLES'
export const ADD_ROLE = 'ADD_ROLE'